export default (state = {}, {res}) => {
  return {
    ...state,
    declineReasons: res,
  };
};
